import { CreateExamPaperPage } from './CreateExamPaperPage';
export default CreateExamPaperPage;
